import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // 24h: lange genug, damit der persistierte IndexedDB-Cache beim Wiederöffnen
      // der PWA noch da ist (sonst wuerde TanStack ihn als 'stale + abgelaufen' wegwerfen).
      gcTime: 24 * 60 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        // Bei 401 (nicht eingeloggt) oder 4xx generell nicht erneut versuchen
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
